import { TokenDecrypt } from "../../Shared/Utils/encryptionDecryption";
import { toast } from "react-toastify";
import {
  successToastStyle,
  errorToastStyle,
} from "../../Shared/Utils/ToastUtils";
import {
  sendOtpFromServer,
  verifyOtpFromServer,
  verifyOtpForNewUserFromServer,
  resendOtpFromServer,
} from "../../../src/Services/NewUserService.js";
export const SEND_OTP = "SEND_OTP";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAILURE = "SEND_OTP_FAILURE"; // Corrected action type
export const VerifyOTP_SETPSWD = "VerifyOTP_SETPSWD";
export const VerifyOTP_SETPSWD_SUCCESS = "VerifyOTP_SETPSWD_SUCCESS";
export const VerifyOTP_SETPSWD_FAILURE = "VerifyOTP_SETPSWD_FAILURE";
export const VERIFYOTP_NEWUSER = "VERIFYOTP_NEWUSER";
export const VERIFYOTP_NEWUSER_SUCCESS = "VERIFYOTP_NEWUSER_SUCCESS";
export const VERIFYOTP_NEWUSER_FAILURE = "VERIFYOTP_NEWUSER_FAILURE";
const OTPSuc = "OTP sent Successfully";
const userNot = "User Not Found";
const mobileNoError = "Mobile No. not Registered.";
const ErrorOtp = "Error in sending OTP";
export const sendOtpcall = (contact, newUser, navigate) => {
  return async (dispatch) => {
    dispatch({ type: SEND_OTP }); // Dispatch action to indicate OTP sending process has started

    try {
      // Call the service function to send OTP
      const response = await sendOtpFromServer(contact);
      dispatch({ type: SEND_OTP_SUCCESS, payload: response });
      toast.success(OTPSuc, { style: successToastStyle });
      if (newUser) {
        navigate("/Login/set-password", { state: { contact, newUser } });
      } else {
        navigate("/Login/reset-password", { state: { contact } });
      }
    } catch (error) {
      let customerrmsg;

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        customerrmsg = error.response.data.message;
      } else if (error.message === userNot) {
        customerrmsg = mobileNoError;
      } else {
        customerrmsg = ErrorOtp;
      }
      dispatch({ type: SEND_OTP_FAILURE, payload: customerrmsg });
    }
  };
};

export const fetchResendOtp = (contact, newUser, navigate) => {
  return async (dispatch) => {
    dispatch({ type: SEND_OTP });

    try {
      const reqBody = {
        mobilenumber: contact,
      };
      const response = await resendOtpFromServer(reqBody);

      if (newUser) {
        toast.success(OTPSuc, { style: successToastStyle });
        navigate("/Login/verifyOtpnewUser", { state: { contact } });
      }
      dispatch({ type: SEND_OTP_SUCCESS, payload: response });
    } catch (error) {
      // need to send error message
      let customerrmsg;
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        customerrmsg = error.response.data.message;
      } else if (error.message === userNot) {
        customerrmsg = mobileNoError;
      } else {
        customerrmsg = ErrorOtp;
      }
      dispatch({ type: SEND_OTP_FAILURE, payload: customerrmsg });
    }
  };
};

export const fetchVerifyOTPNewUSer = (contact, otp, navigate) => {
  return async (dispatch) => {
    dispatch({ type: VERIFYOTP_NEWUSER });
    try {
      const response = await verifyOtpForNewUserFromServer(contact, otp);

      dispatch({ type: VERIFYOTP_NEWUSER_SUCCESS, payload: { response } });
      toast.success("OTP Verified Successfully", {
        style: successToastStyle,
      });
      // Second API call
      try {
        const newUser = true;
        const newUserResponse = await sendOtpFromServer(contact, newUser);
        dispatch({ type: SEND_OTP_SUCCESS, payload: newUserResponse });

        toast.success(OTPSuc, { style: successToastStyle });
        if (newUserResponse) {
          const serializableUserResponse = {
            // Include only properties that are serializable
            id: newUserResponse.id,
            name: newUserResponse.name,
            // Any other properties that you need and are serializable
          };
          navigate("/Login/set-password", {
            state: { contact, newUser: serializableUserResponse },
          });
        } else {
          navigate("/Login/reset-password", { state: { contact } });
        }
      } catch (error) {
        let customerrmsg;

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          customerrmsg = error.response.data.message;
        } else if (error.message === userNot) {
          customerrmsg = mobileNoError;
        } else {
          customerrmsg = ErrorOtp;
        }
        dispatch({ type: SEND_OTP_FAILURE, payload: customerrmsg });
      }
    } catch (error) {
      toast.error(error.message, { style: errorToastStyle });
      dispatch({ type: VERIFYOTP_NEWUSER_FAILURE, payload: error });
    }
  };
};

export const verifySetRestPswd = (
  newUser,
  otp,
  password,
  contact,
  navigate
) => {
  return async (dispatch) => {
    dispatch({ type: VerifyOTP_SETPSWD });

    try {
      const response = await verifyOtpFromServer(
        newUser,
        otp,
        password,
        contact
      );
      if (newUser) {
        const encryptedLoginDetails = response.data.data;

        let loggedUserToken = TokenDecrypt(encryptedLoginDetails);
        sessionStorage.setItem("userToken", encryptedLoginDetails.data);

        const mobileno = loggedUserToken.mobileno;
        const role = loggedUserToken.rolename;
        const usercode = loggedUserToken.usercode;

        dispatch({
          type: VerifyOTP_SETPSWD_SUCCESS,
          payload: { loggedUserToken, mobileno, role, usercode },
        });
      } else {
        let loggedUserToken = response.data;

        const mobileno = loggedUserToken.mobileno;
        const role = loggedUserToken.rolename;
        const usercode = loggedUserToken.usercode;
        dispatch({
          type: VerifyOTP_SETPSWD_SUCCESS,
          payload: { response, mobileno, role, usercode },
        });
      }

      toast.success("Password set Successfully", { style: successToastStyle });

      if (newUser) {
        navigate("/dashboard", { state: { newUser: true } });
      } else {
        navigate("/login");
      }
    } catch (error) {
      let errmsg = "An error occurred";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errmsg = error.response.data.message;
      }
      dispatch({ type: VerifyOTP_SETPSWD_FAILURE, payload: error });
      toast.error(errmsg, { style: errorToastStyle });
    }
  };
};
